import * as React from "react";
import "./routes.css";

const videoWrap = {
  maxWidth: "45rem",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "1rem",
  marginBottom: "1.5rem",
  borderRadius: "0.5rem",
  overflow: "hidden",
  boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 5px 2px",
};
const signature = {
  marginTop: "2rem",
};
const emailLink = {
  color: "#B46000",
  textDecoration: "none",
};

function OmProject() {
  return (
    <div className="pageBg">
      <div className="container">
        <div className="pageCard">
          <h2 className="pageTitle">The OM (AUM) Project</h2>

          <p className="pageLead">
            Help heal the world and raise consciousness in a moment of
            transporting sound. Pass the word, orchestrate a party, share the
            concept, influence the world by sounding 3 OMs at each New Year, 30
            seconds before the ball drops.
          </p>

          <p>Dear Friends of the People and the Planet,</p>

          <p>
            I am writing to you with a vision that came to me, while sitting in
            Quaker Worship, on how to help the planet and our world. It is
            simple and anyone can participate. It would be amazing if the whole
            world were exposed to this vision. We need a good percentage of the
            world involved, to tip the balance of consciousness to a higher
            level.
          </p>

          <h4 className="subTitle">Let&rsquo;s create a World Tradition</h4>

          <p>
            Let&rsquo;s sing into being a Transformative World Tradition. Usher
            in the Light across the World, wherever you are, by sounding 3 OMs
            (AUM) at the start of each New Year. Say O and then mmmmm. OM (AUM)
            resonates with the deep frequency of the Earth and amplifies it.
            Imagine ushering in the Light of each New Year with the Whole Earth
            singing.
          </p>

          <p>
            <strong>Spread the word. Share the concept.</strong>
          </p>

          <p>
            To practice, let&rsquo;s sound 3 OMs on all equinoxes and solstices
            to bring balance to the world. The equinoxes bring equal day and
            night, and the solstices mark the turning points of the year.
            Wherever you are, at these unique times of year, sound 3 OMs by
            yourself or with others and be in good, world wide company.
            Sing transformation of the world into balance, with the whole Earth
            singing.
          </p>

          <p>
            Imagine the host of Time&rsquo;s Square, at New Years, orchestrating
            the entire crowd into sounding 3 OMs, 30 seconds before the ball
            drops!
          </p>

          <p>
            To absorb the idea of OM, listen to my dear friend&rsquo;s music
            video, sent to me in May 2026, after I shared my vision with him in
            April. Benjy Wertheimer, in collaboration with Grammy winning ensemble Opium
            Moon and Jai Uttal, first released this music video on New Years 2025! He was
            amazed by my vision, astonishingly on the same wave length as his,
            though we had never communicated about it. We certainly are all
            connected.
          </p>

          <div style={videoWrap}>
            <div className="ratio ratio-16x9">
              <iframe
                src="https://www.youtube.com/embed/5Pls2fLyqcA"
                title="Om Kara Bhajo - Benjy Wertheimer with Opium Moon"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <p style={signature}>
            Sincerely,
            <br />
            Ann Watkins MA DMT LMT
            <br />
            Owner of New Harmony Therapeutic Massage and Somatic Body Work
            <br />
            <a href="mailto:arwatkins54@gmail.com" style={emailLink}>
              arwatkins54@gmail.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default OmProject;
